















































































































import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

const ADMINISTRATOR_MESSAGE_MAX_COUNT = 500;

export interface AdminMessageSettingProps {
  lang: any;
  supportUrl: string;
  adminMessage: string;
  licenseName: string;
  volumeLicenseId: string;
}

export interface AdminMessageSettingData {
  showModal: boolean;
  isLoading: boolean;
  currentMessage: string;
  draftMessage: string;
  currentScrollAmount: {
    x: number;
    y: number;
  };
}

export default Vue.extend({
  name: "vc-admin-message-setting",
  props: {
    lang: {
      type: Object as PropType<AdminMessageSettingProps["lang"]>,
      default: () => {},
    },
    supportUrl: {
      type: String as PropType<AdminMessageSettingProps["supportUrl"]>,
      default: "",
    },
    licenseName: {
      type: String as PropType<AdminMessageSettingProps["licenseName"]>,
      default: "",
    },
    adminMessage: {
      type: String as PropType<AdminMessageSettingProps["adminMessage"]>,
      default: "",
    },
    volumeLicenseId: {
      type: String as PropType<AdminMessageSettingProps["volumeLicenseId"]>,
      default: "",
    },
  },
  data(): AdminMessageSettingData {
    return {
      showModal: false,
      isLoading: false,
      currentMessage: this.adminMessage,
      draftMessage: this.adminMessage,
      currentScrollAmount: {
        x: 0,
        y: 0,
      },
    };
  },
  mounted() {
    this.updateAdminMessage(this.currentMessage);
  },
  computed: {
    ...mapGetters("adminMessage", ["getAdminMessage"]),
  },
  methods: {
    ...mapActions("common", ["createNotification", "createErrorNotification"]),
    ...mapActions("adminMessage", ["patchAdminMessage"]),
    ...mapMutations("adminMessage", [
      "updateVolumeLicenseId",
      "updateAdminMessage",
    ]),
    async setAdminMessage() {
      this.updateVolumeLicenseId(this.volumeLicenseId);
      this.isLoading = true;
      try {
        await this.patchAdminMessage({ admin_message: this.draftMessage });
        this.currentMessage = this.getAdminMessage;
        this.draftMessage = this.currentMessage;
        this.createNotification({
          label: this.lang.save_complete,
          style: "is-success",
        });
      } catch {
        this.createErrorNotification({
          label: this.lang.save_error_alert,
          style: "is-danger",
          linkLabel: this.lang.link_in_description,
          link: this.supportUrl,
        });
      }
      this.isLoading = false;
      this.closeModal();
    },
    doSend() {
      if (this.draftMessage.length === 0) {
        window.alert(this.lang.input_error.required);
      } else if (this.draftMessage.length > ADMINISTRATOR_MESSAGE_MAX_COUNT) {
        window.alert(
          this.lang.input_error.length.replace(
            ":length",
            ADMINISTRATOR_MESSAGE_MAX_COUNT
          )
        );
      } else if (this.draftMessage === this.adminMessage) {
        window.alert(this.lang.input_error.similar);
      } else {
        this.setAdminMessage();
      }
    },
    openModal() {
      this.showModal = true;
      this.draftMessage = this.currentMessage;

      // モーダルを開いている時は背景がスクロールされないよう現在スクロール位置を保持する
      this.currentScrollAmount = {
        x: window.scrollX || window.pageXOffset,
        y: window.scrollY || window.pageYOffset,
      };
      document.body.classList.add("fixedPosition");
      document.body.style.top = (-this.currentScrollAmount.y).toString() + "px";
      document.body.style.left =
        (-this.currentScrollAmount.x).toString() + "px";
      // position:fixedとするとiOS15で下部に空白が生まれるため全体の高さを指定する
      document.documentElement.style.height = "100vh";
    },
    closeModal() {
      this.showModal = false;
      this.draftMessage = this.currentMessage;

      // モーダルを閉じた時は表示処理をスクロール位置に戻す
      document.body.classList.remove("fixedPosition");
      window.scrollTo(this.currentScrollAmount.x, this.currentScrollAmount.y);
      document.documentElement.style.height = "";
    },
  },
});
